import axios from "axios";
import { handleAPIError, handleAPISuccess, removeEmptyFields } from "./utils/utilsAPI";
import { tokenAndIdValidation, createLocationValidation, getLocationByOwnerIdValidation, locationValidation, addLocationValidation } from "./utils/validateAPI";
import { BASE_URL, getConfig, TEST_URL } from "./constant";
import store from "../store";
import { errToast, successToast } from "../store/dbFilter/actions";

const apiLocationTest = axios.create({
  baseURL: `${TEST_URL}/locations`,
});


// **********************************************TEST API*******************************************************

/**
 * validates the argument received and Makes an API call to get the location by owner Id.
 * @param {string} ID - id of the owner to fetch all the location under them.
 * @returns {Promise} - Resolves when the promise returns all the location or logs in case of failure.
 */
const getLocationById = async (locationId) => {
  const payload = {
    locationId: locationId,
  };
  try {
    await locationValidation.validate(payload);
    const res = await apiLocationTest.get(`/byId`, { params: payload, ...getConfig() });
    const { data } = handleAPISuccess(res);
    if (data?.length === 0) {
      console.log("There are no Locations ");
      store.dispatch(errToast({ title: "Err", message: "Location not found" }));
    }
    return data;
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
  }
};

/**
 * validates the argument received and Makes an API call to create or update the Location
 * @param {object} locationDetail - contains all the data required to create a location
 * @returns {Promise} - Resolves when the promise returns location details  or logs in case of failure.
 */
const addLocation = async (locationDetail) => {
  const obj = removeEmptyFields(locationDetail);
  console.log("add location: ", obj, addLocationValidation);
  try {
    await addLocationValidation.validate(obj);
    const res = await apiLocationTest.post(`/add`, obj, getConfig());
    const { message, data } = handleAPISuccess(res);
    console.log(`${message}`, data);
    store.dispatch(successToast({ title: "Success", message: message }));
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};
export {  getLocationById, addLocation };
